var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMultiple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.968,
    height: 15.968,
    viewBox: "0 0 15.968 15.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2105",
    "data-name": "Trac\\xE9 2105",
    d: "M17.968,13.178V3.6a1.6,1.6,0,0,0-1.6-1.6H6.79a1.6,1.6,0,0,0-1.6,1.6v9.581a1.6,1.6,0,0,0,1.6,1.6h9.581A1.6,1.6,0,0,0,17.968,13.178ZM2,5.194V16.371a1.6,1.6,0,0,0,1.6,1.6H14.775v-1.6H3.6V5.194Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultiple);
export default __webpack_public_path__ + "static/media/icon_multiple.b18ee0bde3d43f0376e8ec015b92d888.svg";
export { ForwardRef as ReactComponent };